import { render, staticRenderFns } from "./DeliveryPartners.vue?vue&type=template&id=65e3d16b&scoped=true&"
import script from "./DeliveryPartners.vue?vue&type=script&lang=js&"
export * from "./DeliveryPartners.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryPartners.vue?vue&type=style&index=0&id=65e3d16b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e3d16b",
  null
  
)

export default component.exports